// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React from "react";
import { TrendingUp, Calendar, BarChart3, ChevronRight } from "lucide-react";

export default function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const bgUrl = "https://static.prod-images.emergentagent.com/jobs/c43d090f-5690-4fac-b31b-075cfc3d2528/images/6d9d797a8a4127e18404b40b1eb32c66eb409094dd25fef960da12bc5d991ee5.png";

  return (
    <div className="min-h-screen bg-champagne grid lg:grid-cols-5">
      {/* Left visual */}
      <div className="hidden lg:flex lg:col-span-3 relative overflow-hidden border-r border-stone bg-graphite">
        <img src={bgUrl} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-br from-graphite/85 via-graphite/70 to-graphite" />
        <div className="absolute inset-0 terminal-grid opacity-30" />

        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-paars flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-graphite" strokeWidth={2.5} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-stone/70">BABYBONDS</div>
              <div className="text-sm font-mono text-champagne">TRACKER</div>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <div className="text-xs tracking-[0.3em] uppercase text-paars mb-4">// DIVIDEND TRACKER</div>
              <h1 className="text-5xl xl:text-6xl font-bold text-champagne leading-[1.05] tracking-tighter">
                Track every coupon.<br/>
                <span className="text-paars glow-paars">Yield with precision.</span>
              </h1>
              <p className="mt-6 text-stone/80 max-w-lg leading-relaxed">
                A purpose-built tracker for retail bond investors. Compute Yield on Cost,
                Yield to Maturity, and forecast every payment from now until maturity.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-px bg-graphite/60 border border-paars-dark/30 max-w-2xl">
              {[
                { icon: TrendingUp, k: "YOC + YTM", v: "Real-time calcs" },
                { icon: Calendar, k: "Forecast", v: "Coupon calendar" },
                { icon: BarChart3, k: "Live Quotes", v: "Auto-priced" },
              ].map(({icon: Icon, k, v}) => (
                <div key={k} className="bg-graphite p-5">
                  <Icon className="w-4 h-4 text-paars mb-3" strokeWidth={1.5} />
                  <div className="text-sm text-champagne font-semibold">{k}</div>
                  <div className="text-xs text-stone/60 mt-1">{v}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-between gap-4">
            <div className="text-xs font-mono text-stone/50 tracking-widest">
              SYS://AUTH_REQUIRED · SESSION_LIFETIME=7D
            </div>
            <a
              href="https://www.dividend.community"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="powered-by-dc-login"
              className="flex items-center gap-3 group"
              title="Powered by Dividend Community"
            >
              <div className="text-right">
                <div className="text-[9px] font-mono tracking-[0.35em] uppercase text-stone/55">POWERED BY</div>
                <div className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone/80 group-hover:text-paars transition-colors">DIVIDEND.COMMUNITY</div>
              </div>
              <img
                src="/brand/dc-logo-light.png"
                alt="Dividend Community"
                className="h-10 w-auto opacity-90 group-hover:opacity-100 transition-opacity"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Right login panel */}
      <div className="lg:col-span-2 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="mb-10 lg:hidden flex items-center gap-3">
            <div className="w-9 h-9 bg-paars flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-graphite" strokeWidth={2.5} />
            </div>
            <div className="text-sm font-mono text-graphite">BABYBONDS.TRACKER</div>
          </div>

          <div className="text-xs tracking-[0.3em] uppercase text-graphite/55 mb-3">// LOGIN_REQUIRED</div>
          <h2 className="text-3xl font-bold text-graphite tracking-tight mb-3">Access your tracker</h2>
          <p className="text-sm text-graphite/60 mb-10 leading-relaxed">
            Sign in with Google to access your private portfolio, dividends history, and yield analytics.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="group w-full bg-paars hover:bg-paars-light text-graphite font-semibold py-4 px-5 flex items-center justify-between transition-colors"
          >
            <span className="flex items-center gap-3">
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#000" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#000" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#000" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#000" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </span>
            <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>

          <div className="mt-8 pt-8 border-t border-stone">
            <div className="text-xs font-mono text-graphite/45 tracking-widest mb-2">SECURITY</div>
            <p className="text-xs text-graphite/55 leading-relaxed">
              Sessions expire after 7 days. We never store passwords — auth is delegated to Google
              via Emergent's OAuth gateway.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
